import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {RightSidebarActionButton} from "../../../layout/rightSidebar/RightSidebarRail";
import {triggerActionFloorplanPrint} from "../../../../store/action.reducer";

export function FloorplanPrintButton() {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    return (
        <RightSidebarActionButton
            icon={<PrintOutlinedIcon/>}
            label={t("Print")}
            onClick={() => dispatch(triggerActionFloorplanPrint())}
        />
    );
}
